import { createFileRoute } from "@tanstack/react-router"
import Component from "@/routes/(app)/_layout/inventory/$itemId/-components/screen"

export const Route = createFileRoute("/(app)/_layout/inventory/$itemId/")({
  component: Component,
})

